import { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Button, Typography, Box } from '@material-ui/core'
import DeleteOutlineOutlined from 'components/material-symbol/icons/DeleteOutline'
import { DetailSection } from './content-box'
import { useStyles } from '../styles'
import DeleteStudentDialog from '../../delete-student-dialog'

export default function DeleteStudent({ student }) {
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false)
  const history = useHistory()
  const classes = useStyles()

  return (
    <DetailSection title="Delete Student" layout="plain" compact>
      <Box className={classes.deleteStudent}>
        <Typography className={classes.deleteText}>
          Delete student, including all data such as transaction history,
          session history, messages, and contact information.
        </Typography>
        <Button
          startIcon={<DeleteOutlineOutlined />}
          variant="outlined"
          color="primary"
          className={classes.deleteActionButton}
          onClick={() => setIsDeleteDialogOpen(true)}
        >
          Delete
        </Button>
        <DeleteStudentDialog
          student={student}
          onSuccess={() => history.push('/pga-coach/students/')}
          open={isDeleteDialogOpen}
          setOpen={setIsDeleteDialogOpen}
        />
      </Box>
    </DetailSection>
  )
}
